﻿export const INSERT = 1;
export const EDIT = 2;
export const MOVE = 3;
export const MAKE_HOLE = 4;
export const SCALE = 5;
export const ROTATE = 6;
export const CUT_LINE = 7;